import { render, staticRenderFns } from "./ColorScaleInput.vue?vue&type=template&id=af741e08&scoped=true&"
import script from "./ColorScaleInput.vue?vue&type=script&lang=js&"
export * from "./ColorScaleInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorScaleInput.vue?vue&type=style&index=0&id=af741e08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af741e08",
  null
  
)

export default component.exports